import styled from 'styled-components';

import { spaceXXL } from '@xing-com/tokens';

export const CenterImage = styled.div`
  text-align: center;
  margin-bottom: ${spaceXXL};
  margin-top: ${spaceXXL};
`;
